import { render, staticRenderFns } from "./series-table.vue?vue&type=template&id=34d450c9&scoped=true&"
import script from "./series-table.vue?vue&type=script&lang=ts&"
export * from "./series-table.vue?vue&type=script&lang=ts&"
import style0 from "./series-table.vue?vue&type=style&index=0&id=34d450c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d450c9",
  null
  
)

export default component.exports